import SkillsDisplayContainer from './skills_display_container';

const SkillsDisplay = SkillsDisplayContainer;
export default SkillsDisplay;
